import React, { useState, useEffect } from 'react';
import { Button, Spin, List, Typography } from 'antd';
import './GetProduct.css'; // Import CSS file for styling
import Web3 from 'web3';
import SupplyChainContract from '../../Contracts/Supplychain.json'; // Import the contract ABI
import detectEthereumProvider from '@metamask/detect-provider';
import { Row, Col } from 'antd';
import { Form, Input } from 'antd';

const { Title } = Typography;

const GetProduct = () => {
    const [web3, setWeb3] = useState(null);
    const [contract, setContract] = useState(null);
    const [account, setAccount] = useState(null);
    const [productID, setproductID] = useState(null);
    const [hasProvider, setHasProvider] = useState(null);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const initWeb3 = async () => {
            const provider = await detectEthereumProvider();
            setHasProvider(Boolean(provider)); // Set the provider existence
            if (provider) {
                startApp(provider);
            } else {
                console.log('Please install MetaMask!');
            }
        };
        initWeb3();
    }, []);

    const startApp = async (provider) => {
        if (provider !== window.ethereum) {
            console.error('Do you have multiple wallets installed?');
        }
        const web3Instance = new Web3(provider);
        setWeb3(web3Instance);
        const accounts = await web3Instance.eth.getAccounts();
        if (accounts.length > 0) {
            setAccount(accounts[0]);
        }
        const networkId = await web3Instance.eth.net.getId();
        const deployedNetwork = SupplyChainContract.networks[networkId];
        const contractInstance = new web3Instance.eth.Contract(
            SupplyChainContract.abi,
            deployedNetwork && deployedNetwork.address,
        );
        setContract(contractInstance);
    };

    const connectWallet = async () => {
        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            if (accounts.length > 0) {
                setAccount(accounts[0]); // Set the first account as the connected wallet
            }
        } catch (error) {
            console.error(error);
        }
    };

    const fetchProductById = async (productId) => {
        setLoading(true); // Set loading state to true to display the loading spinner
        if (contract) {
            try {
                const product = await contract.methods.products(productId).call();
                setProducts([product]); // Set the fetched product as an array to display in the List component
            } catch (error) {
                console.error('Error fetching product:', error);
            }
        }
        setLoading(false); // Set loading state to false after fetching the product
    };
    const onFinish = async (values) => {
        const { productId } = values;
        await fetchProductById(productId);
    };
    
    return (
        <div className="producer-page">
            <div className='HeaderTab'>
                <Title level={3}>Get Products Info</Title>
                <p className='HeaderDescr'>
                    Access detailed information about products stored on the blockchain.
                </p>
            </div>
            <Row justify="center" className="mb-2">
                <Col>
                    <div className="wallet-info">
                        {hasProvider && ( // Only show if provider exists
                            account ? (
                                <>
                                    <p style={{ fontWeight: 'bold' }}>Connected Wallet:</p>
                                    <p style={{ wordWrap: 'break-word' }}>{account}</p>
                                    <Button type="primary" onClick={connectWallet}>Connect Wallet</Button>
                                </>
                            ) : (
                                <Button type="primary" onClick={connectWallet}>Connect Wallet</Button>
                            )
                        )}
                          <div className="wallet-info" style={{ marginTop: '15px' }}>
                           
                          <Form
                            name="product_form"
                            onFinish={onFinish}
                            layout="vertical"
                            style={{ marginTop: '15px' }}
                        >
                            <Form.Item
                                name="productId"
                                label="Product ID"
                                rules={[
                                    { required: true, message: 'Please enter product id' }
                                ]}
                            >
                                <Input placeholder="Enter product ID" />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Get Product
                                </Button>
                               
                            </Form.Item>
                        </Form>
                        </div>
                    </div>
                </Col>
            </Row>
            {loading ? (
                <Row justify="center">
                    <Spin size="large" />
                </Row>
            ) : (
                <List
                    dataSource={products}
                    renderItem={(product, index) => (
                        <List.Item>
                            <List.Item.Meta
                                // title={`Product ${index + 1}`}
                                style={{ wordWrap: 'break-word' }}
                                description={
                                    <>
                                        <div style={{display:"flex"}}>
                                            {/* <div style={{fontWeight:"bold",color:"black"}}>
                                            Product :
                                            </div> */}
                                            <div style={{fontWeight:"Bold",color:"black"}}>
                                            {" " + product.productName + " " + "(" +parseInt(product.productId)  + ")"}
                                            </div>
                                           
                                        </div>
                                        <div style={{marginBottom:"2px"}}>
                                            <div style={{fontWeight:"bold",color:"black"}}>
                                            Producer :
                                            </div>
                                            <div style={{wordWrap: 'break-word'}}>
                                                {product.producer}
                                            </div>
                                        </div>
                                        <div style={{marginBottom:"2px"}}>
                                            <div style={{fontWeight:"bold",color:"black"}}>
                                            Distributor :
                                            </div>
                                            <div style={{wordWrap: 'break-word'}}>
                                                {product.distributor}
                                            </div>
                                        </div>
                                        <div style={{marginBottom:"2px"}}>
                                            <div style={{fontWeight:"bold",color:"black"}}>
                                            Retailer :
                                            </div>
                                            <div style={{wordWrap: 'break-word'}}>
                                                {product.retailer}
                                            </div>
                                        </div>
                                        <div style={{marginBottom:"2px"}}>
                                            <div style={{fontWeight:"bold",color:"black"}}>
                                            Consumer :
                                            </div>
                                            <div style={{wordWrap: 'break-word'}}>
                                                {product.consumer}
                                            </div>
                                        </div>
                                    </>
                                }
                            />
                        </List.Item>
                    )}
                />
            )}
        </div>
    );
}

export default GetProduct;
